import { useMutation } from "@tanstack/react-query";
import { getApiInstance } from "../utils/api";
import { setTokens, clearTokens, getTokens } from "@/utils/token";

const api = getApiInstance();

// Helper: normalize Saudi phone numbers to E.164 (+966...)
const toE164Ksa = (input: string): string => {
  if (!input) return input;
  let s = String(input).trim();
  // remove spaces and dashes
  s = s.replace(/\s+/g, "").replace(/-/g, "");
  // handle 00 international prefix
  if (s.startsWith("00")) s = s.replace(/^00+/, "");
  // strip leading + for processing
  if (s.startsWith("+")) s = s.slice(1);
  // keep digits only
  s = s.replace(/\D/g, "");
  // drop country code if present
  if (s.startsWith("966")) s = s.slice(3);
  // drop leading 0 of local format (e.g., 05XXXXXXXX)
  if (s.startsWith("0")) s = s.slice(1);
  return `+966${s}`;
};

function saveTokens(access: string, refresh: string) {
  setTokens(access, refresh);
}

export function logout() {
  clearTokens();
  // تنظيف البيانات المحلية المرتبطة بالجلسة
  localStorage.removeItem("sessionStarted");
  localStorage.removeItem("lastQROperation");
}

export function useLogin() {
  return useMutation({
    mutationFn: (data: { phone: string; password: string }) => {
      const payload = { ...data, phone: toE164Ksa(data.phone) };
      return api.post("/auth/jwt/create/?cashier", payload).then((res) => {
        saveTokens(res.data.access, res.data.refresh);
        return res.data;
      });
    },
  });
}

export function useTokenRefresh() {
  return useMutation({
    mutationFn: (data: { refresh: string }) =>
      api.post("/auth/jwt/refresh/", data).then((res) => {
        const { refresh } = getTokens();
        setTokens(res.data.access, refresh || "");
        return res.data;
      }),
  });
}

export function useTokenVerify() {
  return useMutation({
    mutationFn: (data: { token: string }) =>
      api.post("/auth/jwt/verify/", data).then((res) => res.data),
  });
}
